<script>
	export default {
		name: 'OneSignalExecuter',
		methods: {
			initOneSignal() {
				const self_ = this;

				if(self_.env.dev) { return }

				self_.oneSignal.push(() => {
					Promise.resolve().then(() => {
						return self_.oneSignal.init({ appId: self_.oneSignalAppId })
					}).then(() => {
						return self_.oneSignal.getUserId()
					}).then(result => {
						const app_ = self_.getState('app')
						app_.oneSignal.userId = result;

/* debug */				self_.logDebug('One Signal Initialization', 'userId', result)
					}).catch(error => {
/* error */				self_.logError('Error', 'initOneSignal()', error)
					})
				})
			},
			oneSignalSendTag(tag) {
				const self_ = this;
				// initialization check
				const oneSignal_ = self_.getAppState('oneSignal')
				if(self_.isFalse(oneSignal_.userId)) { return }

				self_.oneSignal.push(() => {
					// uid tag
					if(self_.isFalse(tag.uid)) { self_.oneSignal.deleteTag('uid') }
					else { self_.oneSignal.sendTag('uid', tag.uid) }
					// group tag
					if(self_.isEmpty(tag.group)) { self_.oneSignal.deleteTag('group') }
					else { self_.oneSignal.sendTag('group', tag.group) }

/* debug */			self_.logDebug('One Signal Send Tag', '', { uid: tag.uid, group: tag.group })
				})
			},
			oneSignalPushNotificationByUid(uid, title, text, url) { 
				const self_ = this;

				const message_ = {
					title: title,
					text: text,
					url: url
				}

				let target_ = {
					uid: uid,
					group: null
				}

				return self_.$_oneSgnlExec_push(target_, message_)
			},
			oneSignalPushNotificationByGroup(groupCode, title, text, url) { 
				const self_ = this;

				const message_ = {
					title: title,
					text: text,
					url: url
				}

				let target_ = {
					uid: null,
					group: groupCode
				}

				return self_.$_oneSgnlExec_push(target_, message_)
			},
			$_oneSgnlExec_push(target, message) { 
				// message = { title: title, text: text, url: url }
				// target = { uid: uid, group: group }
				const self_ = this;

				let body_ = {
					target: target,
					message: message
				}

				body_.env = self_.env;

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.callFunction('pushNotificationFunction', 'post' , { body: body_ })
					}).then(() => {
/* debug */				self_.logDebug('One Signal Push Notification', '', { message: message, target: target })
						resolve()
					}).catch(error => {
						reject(error)
					})
				})
			}
		}
	}
</script>